import { KeyValue } from "@angular/common";

export class UdeuStatus {
    status: string | KeyValue<string, string>;
    observations: string;

    constructor(status: string, observations?: string) {
        this.status = status;
        this.observations = observations;
    }
}